export default __webpack_public_path__ + "static/media/Chat-Numbers-System-09.c8847ed3.svg";